<template>
	<div class="FilterList">
		<CheckBoxSelectItem
			v-for="item in sortedItems"
			:key="item.value"
			:item="item"
			@selectionChange="(state) => handleSelectionChange(item, state)"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CheckBoxSelectItem from '@components/CheckBoxSelectItem/CheckBoxSelectItem.vue';
import { SpecialProgrammesFilterMapper } from '@app/routing/mappers/SpecialProgrammesFilterMapper';
import { useCheckboxFilter } from '@composables/useCheckboxFilter';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { sortSelectItems } from '@app/utils/sort-helper';

const { items, handleSelectionChange } = useCheckboxFilter(
	SpecialProgrammesFilterMapper.getInstance(),
	FilterType.SPECIAL_PROGRAMMES
);

const sortedItems = computed(() => sortSelectItems(items.value));
</script>

<style scoped lang="scss">
.FilterList {
	width: 100%;
	padding-right: 2px;	// required for outline not to be cut off
}
</style>
